import React, { useState } from "react";
import GoogleLogo from "../../../images/google-logo.svg";
import FacebookLogo from "../../../images/v2/facebook-icon.svg";
import MicrosoftLogo from "../../../images/v2/microsoft-logo.svg";
import EmailLogo from "../../../images/v2/email-logo.svg";
import AppleLogo from "../../../images/v2/apple-logo.svg";
import { Button, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

const UserSocialSignUpModal = (props) => {
  const { OAuthLogin, emailLogin, isLoading, platform, isMobile } = props;

  const buttonClass = isMobile
    ? "btn btn-outline-primary w-100 mb-2 social-login-btn-mob"
    : "btn outline-btn w-100 mb-2 social-login-btn";

  const handleLogin = async (provider) => {
    try {
      if (provider === "email") {
        await emailLogin();
      } else {
        await OAuthLogin(provider);
      }
    } catch {
      toast.error(`login canceled or failed!. Please try again.`);
    }
  };

  const renderButtonContent = (provider, logo, text) => (
    <>
      {isLoading && platform === provider ? (
        <Spinner animation="border" size="sm" className="me-2" />
      ) : (
        <img src={logo} className="me-2 social-login-icon" />
      )}
      <span>{text}</span>
    </>
  );

  return (
    <>
      <div className="mb-4">
        <Button
          variant="outline-primary user-social-login-btn"
          className={buttonClass}
          onClick={() => handleLogin("google")}
          disabled={isLoading}
        >
          {renderButtonContent("google", GoogleLogo, "Continue With Google")}
        </Button>
      </div>
    </>
  );
};

export default UserSocialSignUpModal;
